import { Form, Input } from "antd";
import { FormattedMessage, useIntl } from "react-intl";

type Props = {};

const NameAndEmail = (props: Props) => {
  const intl = useIntl();
  return (
    <>
      <h5 className="w-full mb-4 text-lg font-normal text-center text-color-gray md:my-8">
        <FormattedMessage
          id="project_name"
          defaultMessage="Tell us about your project"
        />
      </h5>
      <div className="flex justify-center w-full gap-4 max-md:flex-wrap max-md:gap-2 max-lg:px-5">
        <Form.Item
          label={intl.formatMessage({ id: "project_name" })}
          name={["name", "ar"]}
          className="w-full max-md:w-full max-xl:w-[25rem]"
          rules={[
            {
              required: true,
              message: intl.formatMessage({ id: "enter_project_name" }),
            },
          ]}
          required={false}
          hasFeedback
        >
          <Input
            placeholder={intl.formatMessage({ id: "enter_project_name" })}
          />
        </Form.Item>
        <Form.Item
          label={
            <>
              <div className="whitespace-nowrap">
                <FormattedMessage
                  id="optional_website"
                  defaultMessage="Your project's website (optional)"
                />
              </div>
              <small className="text-xs self-center mt-2 text-[#75757E] mx-1">
                ({intl.formatMessage({ id: "optional" })})
              </small>
            </>
          }
          name="website_url"
          className="w-full max-md:w-full max-xl:w-[25rem]"
          required={false}
          rules={[
            {
              type: "url",
              message: intl.formatMessage({ id: "valid_url_required" }),
            },
          ]}
        >
          <Input placeholder={intl.formatMessage({ id: "enter_website" })} />
        </Form.Item>
      </div>
    </>
  );
};

export default NameAndEmail;
